module.exports = __webpack_public_path__ + "static/media/stall.6032362c.png";